import { Stack } from "@mui/material";
import React from "react";
import TopNavigationButton from "../Buttons/TopNavigationButton";
import SearchIcon from '@mui/icons-material/Search';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import AgricultureOutlinedIcon from '@mui/icons-material/AgricultureOutlined';

import logo from "../../../Assets/pasargad-logo.png"

const navigationData = [
    {
        Id: 1,
        Title: "Multisearch",
        Link: "/",
        colorValue: "#E6E6EF",
        Icon: <SearchIcon sx={{color: "#19176E", fontSize: "2rem"}} />
    },
    {
        Id: 2,
        Title: "Search By State/Territory",
        Link: "/",
        colorValue: "#FFEEE9",
        Icon: <MapOutlinedIcon sx={{color: "#FF6633", fontSize: "2rem"}} />
    },
    {
        Id: 3,
        Title: "Search By Task",
        Link: "/",
        colorValue: "#F1E7FC",
        Icon: <FormatListBulletedOutlinedIcon sx={{color: "#8224E3", fontSize: "2rem"}} />
    },
    {
        Id: 4,
        Title: "VAC Search",
        Link: "/",
        colorValue: "#E8FAF4",
        Icon: <AttachMoneyOutlinedIcon sx={{color: "#2ED397", fontSize: "2rem"}} />
    },
    {
        Id: 5,
        Title: "DAMA",
        Link: "/",
        colorValue: "#E6E6EF",
        Icon: <AgricultureOutlinedIcon sx={{color: "#19176E", fontSize: "2rem"}} />
    },
]

export default function TopMenu() {
    return (
        <Stack direction="row" sx={{width: "100%", mb: "-1rem !important", justifyContent: {xs: "center", lg: "flex-start"}}}>
            {/* {
                navigationData.map((val, i) => {
                    return (
                        <TopNavigationButton
                            key={val.Id}
                            icon={val.Icon}
                            link={val.Link}
                            title={val.Title}
                            colorValue={val.colorValue}
                        />
                    )
                })
            } */}
            <img style={{mixBlendMode: "darken", width: "200px"}} src={logo} alt="pasargad migration logo" />
        </Stack>
    )
}